'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
var classNames = require('classnames');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var Image = function Image(_ref) {
  var className = _ref.className,
    _ref$mounted = _ref.mounted,
    mounted = _ref$mounted === void 0 ? false : _ref$mounted,
    _ref$lazyLoad = _ref.lazyLoad,
    lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad,
    src = _ref.src,
    src2x = _ref.src2x,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? '' : _ref$alt,
    size = _ref.size;
  var lazyLoadClass = lazyLoad ? 'lazy-loadable' : '';
  var imgSrc = !mounted && lazyLoad ? 'data-src' : 'src';
  return /*#__PURE__*/React__default["default"].createElement("img", _defineProperty(_defineProperty(_defineProperty({
    alt: alt,
    width: size,
    height: size
  }, imgSrc, src), "srcSet", src2x && "".concat(src, " 1x, ").concat(src2x, " 2x")), "className", classNames__default["default"](className, lazyLoadClass)));
};
var Image$1 = Image;
var REACT_ELEMENT_TYPE$1;
function _createRawReactElement$1(e, r, E, l) {
  REACT_ELEMENT_TYPE$1 || (REACT_ELEMENT_TYPE$1 = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE$1,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var Section = function Section(_ref) {
  var children = _ref.children,
    className = _ref.className,
    style = _ref.style,
    type = _ref.type;
  return /*#__PURE__*/_createRawReactElement$1("section", {
    className: classNames__default["default"](type, className),
    style: style
  }, void 0, children);
};
var Section$1 = Section;
var THEME = {
  LEGEND: 'legend',
  EXPLORER: 'explorer'
};
var THEME$1 = THEME;
var Icon$1 = function Icon(_ref) {
  var color = _ref.color;
  return React__default["default"].createElement('svg', {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    fill: color
  }, /* #__PURE__ */React__default["default"].createElement('path', {
    d: 'M12.428 7.40562L7.54559 2.54246L8.39244 1.69226L14.7251 7.99995L8.39244 14.3076L7.54559 13.4574L12.4166 8.60562H1.2749V7.40562H12.428Z',
    fill: color
  }));
};
Icon$1.defaultProps = {
  color: 'rgba(0, 0, 0, 0.9)'
};
var ArrowRight16 = Icon$1;
var ArrowRight16_1 = ArrowRight16;
var ArrowRight16$1 = ArrowRight16_1;
var Icon = function Icon(_ref) {
  var color = _ref.color;
  return React__default["default"].createElement('svg', {
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    fill: color
  }, /* #__PURE__ */React__default["default"].createElement('path', {
    d: 'M5.95028 4.40041L9.54667 7.9968L5.94653 11.5969L6.79506 12.4455L11.2437 7.9968L6.79881 3.55188L5.95028 4.40041Z',
    fill: color
  }));
};
Icon.defaultProps = {
  color: 'rgba(0, 0, 0, 0.9)'
};
var ChevronRight16 = Icon;
var ChevronRight16_1 = ChevronRight16;
var ChevronRight16$1 = ChevronRight16_1;
var _ChevronRight, _ArrowRight, _Fragment;
var IconContainer = function IconContainer(_ref) {
  var layoutTheme = _ref.layoutTheme;
  var Icon = null;
  if (layoutTheme === THEME$1.LEGEND) {
    Icon = _ChevronRight || (_ChevronRight = /*#__PURE__*/_createRawReactElement$1(ChevronRight16$1, {}));
  } else if (layoutTheme === THEME$1.EXPLORER) {
    Icon = _ArrowRight || (_ArrowRight = /*#__PURE__*/_createRawReactElement$1(ArrowRight16$1, {}));
  } else {
    Icon = _Fragment || (_Fragment = /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null));
  }
  return Icon;
};
var IconContainer$1 = IconContainer;
var HeaderCategory = function HeaderCategory(_ref) {
  var cta = _ref.cta,
    _ref$hasButtonAction = _ref.hasButtonAction,
    hasButtonAction = _ref$hasButtonAction === void 0 ? true : _ref$hasButtonAction,
    _ref$hasPriceCategory = _ref.hasPriceCategory,
    hasPriceCategory = _ref$hasPriceCategory === void 0 ? true : _ref$hasPriceCategory,
    _ref$hasTitleCategory = _ref.hasTitleCategory,
    hasTitleCategory = _ref$hasTitleCategory === void 0 ? true : _ref$hasTitleCategory,
    layoutTheme = _ref.layoutTheme,
    price = _ref.price,
    subtitle = _ref.subtitle,
    titleCategory = _ref.title;
  var title = hasTitleCategory && /*#__PURE__*/_createRawReactElement$1("p", {
    className: "section-category-item__title font-secondary-text"
  }, void 0, titleCategory);
  var priceContainer = hasPriceCategory && /*#__PURE__*/_createRawReactElement$1("div", {
    className: "section-category-item__price-container"
  }, void 0, /*#__PURE__*/_createRawReactElement$1("p", {
    className: "section-category-item__subtitle font-secondary-text"
  }, void 0, subtitle), /*#__PURE__*/_createRawReactElement$1("span", {
    className: "section-category-item__price font-secondary-text"
  }, void 0, price));
  var buttonContainer = hasButtonAction && /*#__PURE__*/_createRawReactElement$1("div", {
    className: "section-category-item__button-container"
  }, void 0, /*#__PURE__*/_createRawReactElement$1("button", {
    className: "section-category-item__button font-secondary-text"
  }, void 0, cta), /*#__PURE__*/_createRawReactElement$1(IconContainer$1, {
    theme: layoutTheme
  }));
  if (layoutTheme === (THEME$1 === null || THEME$1 === void 0 ? void 0 : THEME$1.LEGEND) || layoutTheme === (THEME$1 === null || THEME$1 === void 0 ? void 0 : THEME$1.EXPLORER)) {
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, title, /*#__PURE__*/_createRawReactElement$1("div", {
      className: "section-category-item__price-cta-container"
    }, void 0, priceContainer, buttonContainer));
  }
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, title, priceContainer, buttonContainer);
};
var HeaderCategory$1 = HeaderCategory;
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
var isInternal = function isInternal(target, domain) {
  if (!target || !domain) {
    return false;
  }
  if (target.startsWith('/')) {
    return true;
  }
  try {
    var parseTarget = new URL(target).hostname.replace('www.', '');
    var cleanDomain = domain.replace('www.', '');
    return parseTarget === cleanDomain;
  } catch (_unused) {
    return false;
  }
};
var isInternal$1 = isInternal;
var _excluded$2 = ["label", "children", "target", "domain", "isSelf"];
var Action = function Action(_ref) {
  var label = _ref.label,
    children = _ref.children,
    target = _ref.target,
    domain = _ref.domain,
    _ref$isSelf = _ref.isSelf,
    isSelf = _ref$isSelf === void 0 ? false : _ref$isSelf,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var internalLink = isSelf || isInternal$1(target, domain);
  var targetLink = internalLink ? '_self' : '_blank';
  var relValue = internalLink ? '' : 'noopener noreferrer nofollow';
  var linkProps = _objectSpread2({
    href: target,
    target: targetLink,
    rel: relValue
  }, props);
  return /*#__PURE__*/React__default["default"].createElement("a", linkProps, label || children);
};
var Action$1 = Action;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var _excluded$1 = ["className", "component", "type", "color", "weight", "size"];
var namespace$1 = 'typography';
var TYPES$1 = {
  BODY: 'body',
  TITLE: 'title',
  SUBTITLE: 'subtitle'
};
var SIZES$1 = {
  XLARGE: 'xlarge',
  LARGE: 'large',
  MEDIUM: 'medium',
  SMALL: 'small',
  XSMALL: 'xsmall',
  XXSMALL: 'xxsmall'
};
var WEIGHTS = {
  REGULAR: 'regular',
  SEMIBOLD: 'semibold',
  BOLD: 'bold'
};
var ANDES_GRAY_900 = '#1A1A1A';
const Typography = /*#__PURE__*/function () {
  const Typography = function Typography(_ref) {
    var className = _ref.className,
      component = _ref.component,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? TYPES$1.BODY : _ref$type,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? ANDES_GRAY_900 : _ref$color,
      _ref$weight = _ref.weight,
      weight = _ref$weight === void 0 ? WEIGHTS.REGULAR : _ref$weight,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? SIZES$1.MEDIUM : _ref$size,
      otherProps = _objectWithoutProperties(_ref, _excluded$1);
    var getComponent = function getComponent() {
      if (component) {
        return component;
      }
      if (type === TYPES$1.TITLE) {
        switch (size) {
          case SIZES$1.MEDIUM:
            return 'h2';
          case SIZES$1.SMALL:
            return 'h3';
          case SIZES$1.XSMALL:
            return 'h4';
          default:
            return 'p';
        }
      }
      return 'p';
    };
    var Component = getComponent();
    var typographyClassNames = classNames__default["default"](namespace$1, className, _defineProperty(_defineProperty(_defineProperty({}, "".concat(namespace$1, "--type-").concat(type), type), "".concat(namespace$1, "--size-").concat(size), size), "".concat(namespace$1, "--weight-").concat(weight), weight));
    return /*#__PURE__*/React__default["default"].createElement(Component, _extends({
      className: typographyClassNames,
      style: {
        color: color
      }
    }, otherProps));
  };
  Typography.displayName = 'Typography';
  return Typography;
}();
var Typography$1 = Typography;
var TYPES = {
  SELLER: 'seller',
  SUPER: 'super',
  SUPER_PARTNER: 'super_partner',
  BRAND: 'brand',
  DEFAULT: 'eshop',
  LANDING: 'landing'
};
var VARIANTS_BUTTONS = {
  NEUTRAL: 'neutral',
  SECONDARY: 'secondary'
};
var VAR_CSS = {
  VAR_BUTTON_NEUTRAL_IDLE_COLOR: 'var(--button-neutral-idle-color, var(--colorTextVar))',
  VAR_COLOR_OR_BLACK_BY_PRIMARY_COLOR: 'var(--colorOrBlackByPrimaryColor)',
  VAR_PRIMARY_TEXT_COLOR_VAR: 'var(--primaryTextColorVar)'
};
var ANDES_BLUE_500 = '#3483FA';
var constants = {
  TYPES: TYPES,
  VARIANTS_BUTTONS: VARIANTS_BUTTONS,
  VAR_CSS: VAR_CSS,
  ANDES_BLUE_500: ANDES_BLUE_500
};
var constants$1 = constants;
var Button = function Button(_ref) {
  var cta = _ref.cta,
    variant = _ref.variant,
    href = _ref.href,
    size = _ref.size,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    _ref$isSpan = _ref.isSpan,
    isSpan = _ref$isSpan === void 0 ? false : _ref$isSpan,
    className = _ref.className,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? false : _ref$withIcon,
    children = _ref.children;
  var NEUTRAL = constants$1.VARIANTS_BUTTONS.NEUTRAL,
    SECONDARY = constants$1.VARIANTS_BUTTONS.SECONDARY;
  var VAR_BUTTON_NEUTRAL_IDLE_COLOR = constants$1.VAR_CSS.VAR_BUTTON_NEUTRAL_IDLE_COLOR,
    VAR_COLOR_OR_BLACK_BY_PRIMARY_COLOR = constants$1.VAR_CSS.VAR_COLOR_OR_BLACK_BY_PRIMARY_COLOR,
    VAR_PRIMARY_TEXT_COLOR_VAR = constants$1.VAR_CSS.VAR_PRIMARY_TEXT_COLOR_VAR;
  var buttonClass = classNames__default["default"]('button', _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "button--".concat(variant), variant), "button--".concat(size), size), "button--full-width", fullWidth), "button--with-icon", withIcon), "".concat(className), className));
  var sizeTypoByButtonSize = {
    xlarge: 'large',
    large: 'medium',
    medium: 'small',
    small: 'xsmall'
  };
  var Element = isSpan ? 'span' : 'a';
  var getColorTypography = function getColorTypography(currentVariant) {
    if (currentVariant === NEUTRAL) {
      return VAR_BUTTON_NEUTRAL_IDLE_COLOR;
    }
    if (currentVariant === SECONDARY) {
      return VAR_COLOR_OR_BLACK_BY_PRIMARY_COLOR;
    }
    return VAR_PRIMARY_TEXT_COLOR_VAR;
  };
  var colorTypography = getColorTypography(variant);
  return /*#__PURE__*/_createRawReactElement$1(Element, {
    href: href,
    className: buttonClass
  }, void 0, withIcon && children && /*#__PURE__*/_createRawReactElement$1("div", {
    className: "button--icon"
  }, void 0, children), /*#__PURE__*/_createRawReactElement$1(Typography$1, {
    color: colorTypography,
    type: "body",
    size: sizeTypoByButtonSize[size],
    weight: "semibold"
  }, void 0, cta));
};
var Button$1 = Button;
var _span;
var PromotionTag = function PromotionTag(_ref) {
  var primaryLabel = _ref.primaryLabel,
    secondaryLabel = _ref.secondaryLabel;
  var discountBoxClasses = classNames__default["default"]('ui-item__discount-box', {
    'ui-item__discount-box--short-text': !secondaryLabel
  });
  var discountBoxTextClasses = classNames__default["default"]('ui-item__discount-text');
  var discountBoxTextSecondaryClasses = classNames__default["default"]('ui-item__discount-text', {
    'ui-item__discount-text--secondary': Boolean(secondaryLabel)
  });
  return /*#__PURE__*/_createRawReactElement$1("div", {
    className: discountBoxClasses
  }, void 0, /*#__PURE__*/_createRawReactElement$1("span", {
    className: discountBoxTextClasses
  }, void 0, primaryLabel), secondaryLabel && /*#__PURE__*/_createRawReactElement$1("span", {
    component: _span || (_span = /*#__PURE__*/_createRawReactElement$1("span", {})),
    className: discountBoxTextSecondaryClasses
  }, void 0, secondaryLabel));
};
PromotionTag.displayName = 'PromotionTag';
var PromotionTag$1 = PromotionTag;
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
const Asset = _ref => {
  let {
    color = "rgba(0, 0, 0, 0.9)",
    i18n: i18n,
    srLabel: srLabel
  } = _ref;
  return _createRawReactElement("svg", {
    "aria-hidden": srLabel ? void 0 : !srLabel,
    "aria-label": srLabel || void 0,
    role: srLabel ? "img" : void 0,
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: color
  }, void 0, srLabel && _createRawReactElement("title", {}, void 0, srLabel), _createRawReactElement("path", {
    d: "M4.89779 1.85229L4.10229 2.64779L7.45455 6.00004L4.10229 9.35229L4.89779 10.1478L9.04554 6.00004L4.89779 1.85229Z",
    fill: color
  }));
};
var _excluded = ["className", "size", "href", "text", "isSpan", "color"];
var namespace = 'link';
var SIZES = {
  MEDIUM: 'medium',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
const Link = /*#__PURE__*/function () {
  const Link = function Link(_ref) {
    var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? SIZES.MEDIUM : _ref$size,
      href = _ref.href,
      text = _ref.text,
      _ref$isSpan = _ref.isSpan,
      isSpan = _ref$isSpan === void 0 ? false : _ref$isSpan,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? constants$1.ANDES_BLUE_500 : _ref$color,
      otherProps = _objectWithoutProperties(_ref, _excluded);
    var linkClassNames = classNames__default["default"](namespace, className);
    var Element = isSpan ? 'span' : 'a';
    return /*#__PURE__*/_createRawReactElement$1("div", {
      className: "link-container"
    }, void 0, /*#__PURE__*/React__default["default"].createElement(Element, _extends({
      className: linkClassNames,
      href: href,
      rel: "noreferrer noopener",
      target: "_blank"
    }, otherProps), /*#__PURE__*/_createRawReactElement$1(Typography$1, {
      type: "body",
      size: size,
      weight: "semibold",
      color: color
    }, void 0, text)), /*#__PURE__*/_createRawReactElement$1(Asset, {
      color: color
    }));
  };
  Link.displayName = 'Link';
  return Link;
}();
var Link$1 = Link;
var PICTURE_API_VARIATIONS = {
  1920: 'OO',
  1200: 'F',
  800: 'B',
  500: 'O',
  400: 'C',
  320: 'V',
  280: 'E',
  250: 'P',
  228: 'A',
  210: 'Y',
  200: 'N',
  160: 'T',
  120: 'G',
  90: 'I',
  70: 'R',
  40: 'M'
};
var getImageVariation = function getImageVariation(requiredSize, imageUrl) {
  if (!requiredSize || !imageUrl) {
    return imageUrl;
  }
  var picturesApiUrl = /(https:\/\/http2\.mlstatic\.com\/(?:D_|N?Q_|N?P_)*\d+-(MLA|MLM|MLB|MCO|MLC)\d+_\d+)-[A-Z]+\.(?:webp|jpg|png)/;
  var match = imageUrl.match(picturesApiUrl);
  if (match) {
    var sizes = Object.keys(PICTURE_API_VARIATIONS).map(Number).sort(function (a, b) {
      return a - b;
    });
    var closestSize = sizes.find(function (size) {
      return size >= requiredSize;
    }) || sizes[sizes.length - 1];
    return "".concat(match[1], "-").concat(PICTURE_API_VARIATIONS[closestSize], ".webp");
  }
  return imageUrl;
};
var getImageVariation$1 = getImageVariation;
var EshopsComponentsTitles = function EshopsComponentsTitles(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    showTitle = _ref.showTitle,
    showSubTitle = _ref.showSubTitle,
    deviceType = _ref.deviceType,
    titleClassName = _ref.titleClassName,
    subtitleClassName = _ref.subtitleClassName;
  var namespace = 'eshops-components-titles-container';
  var isMobile = deviceType === 'mobile';
  var titleContainerClassnames = classNames__default["default"](namespace, _defineProperty(_defineProperty({}, "".concat(namespace, "--desktop"), !isMobile), "".concat(namespace, "--mobile"), isMobile));
  return /*#__PURE__*/_createRawReactElement$1("div", {
    className: titleContainerClassnames
  }, void 0, showTitle && title && /*#__PURE__*/_createRawReactElement$1(Typography$1, {
    type: "title",
    weight: "bold",
    size: isMobile ? 'small' : 'medium',
    className: titleClassName
  }, void 0, title), showSubTitle && subtitle && /*#__PURE__*/_createRawReactElement$1(Typography$1, {
    type: "subtitle",
    weight: "regular",
    size: isMobile ? 'x-small' : 'small',
    className: subtitleClassName
  }, void 0, subtitle));
};
var EshopsComponentsTitles$1 = EshopsComponentsTitles;
exports.Action = Action$1;
exports.Button = Button$1;
exports.EshopsComponentsTitles = EshopsComponentsTitles$1;
exports.HeaderCategory = HeaderCategory$1;
exports.Image = Image$1;
exports.Link = Link$1;
exports.PromotionTag = PromotionTag$1;
exports.Section = Section$1;
exports.Typography = Typography$1;
exports.getImageVariation = getImageVariation$1;
